import styled from '@emotion/styled'

export const Container = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 30px 4px 50px;
  justify-content: space-between;
`

export const FlexBox = styled.div`
  align-items: flex-end;
  display: flex;
  gap: 10px;
`

export const Message = styled.p`
  font-size: 12px;
  margin: 0;
`
